export enum ShapePrimative {
	HEX,
	TRIANGLE,
	CIRCLE,
	SQUARE
}

